import React from 'react'
import { Basketball, Belote, Catan, DnD, Football, Handball, Meetup, NightOut, OtherSport, Poker, Tennis, Volunteer, Workshop } from '../../assets/icons/IconComponents';
import '../../assets/styles/style.scss'
import { useTranslation } from 'react-i18next';


export default function CategoriesPart() {
  const { t } = useTranslation()
  
  return (
    <div className="categories-part">
      <h3>{t('current_categories')}</h3>
      <div className="fx list">
        <div className="mar-20">
          <h3>{t('sport')}</h3>
          <span className="icon-tag"> <Football /> {t('football')} </span>
          <span className="icon-tag"> <Basketball /> {t('basketball')} </span>
          <span className="icon-tag"> <Tennis /> {t('tennis')} </span>
          <span className="icon-tag"> <Handball /> {t('handball')} </span>
        </div>
        <div className="mar-20">
          <h3>{t('social')}</h3>
          <span className="icon-tag"> <Meetup /> {t('meetup')} </span>
          <span className="icon-tag"> <NightOut /> {t('night_out')} </span>
          <span className="icon-tag"> <Volunteer /> {t('volunteering')} </span>
          <span className="icon-tag"> <Workshop /> {t('workshop')} </span>
        </div>
        <div className="mar-20">
          <h3>{t('board_games')}</h3>
          <span className="icon-tag"> <Belote /> {t('belote')} </span>
          <span className="icon-tag"> <Catan /> {t('catan')} </span>
          <span className="icon-tag"> <DnD /> {t('dnD')} </span>
          <span className="icon-tag"> <Poker /> {t('poker')} </span>
        </div>
      </div>
      <div className="other">
        {t('or_add_other_info')}
      </div>
    </div>
  );
}

